<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Assign Zones to {{ zone.name }}</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="card">
          <div class="card-header bg-hub-primary text-white">
            Available Zones
          </div>
          <div class="card-block">
              <select 
                multiple
                class="form-control devices-select"
                v-model="selected_available_zones" v-if="zone.site_id === 1"
                :size="available_zones.length < 10 ? 10 : available_zones.length > 20 ? 20 : available_zones.length"
              >
                <option v-for="zone in available_zones" :key="zone.zone_id" v-bind:value="zone.zone_id">
                  {{ (scoped_site_id === 1 ? "[" + zone.site.name + "]" : "") }} {{ zone.name }}
                </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-2 middle-btn-col">
        <div class="btn-group-vertical">
          <button id="ToAssignedList" type="button" class="btn btn-light" @click="toAssignedList()">
            <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>
          </button>
          <button id="ToAvailableList" type="button" class="btn btn-light" @click="toAvailableList()">
            <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="col-5">
        <div class="card">
          <div class="card-header bg-hub-primary text-white">
            Assigned Zones
          </div>
          <div class="card-block">
            <select 
              multiple 
              class="form-control devices-select"
              v-model="selected_assigned_zones"
              :size="zone.zone_zones.length < 10 ? 10 : zone.zone_zones.length > 20 ? 20 : zone.zone_zones.length"
            >
              <option v-for="zone_zone in zone.zone_zones" :key="zone_zone.zone_zone_id" v-bind:value="zone_zone.child_zone_id">
                {{ (scoped_site_id === 1 ? "[" + zone_zone.child_zone.site.name + "]" : "") }} {{ zone_zone.child_zone.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <br><br>
    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
        <router-link :to="{ name: 'ZoneManager' }" class="btn btn-secondary">Cancel</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: [
    'zone_id'
  ],
  data: function () {
    return {
      selected_assigned_zones: [],
      selected_available_zones: []
    }
  },
  computed: {
    ...mapGetters({
      zone: 'singleZone',
      available_zones: 'availableZones',
      scoped_site_id: 'scopedSiteId'
    }),

    ordered_available_zones: function () {
      return _.orderBy(this.available_zones, 'name')
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)

    this.$store.dispatch('getZone', this.zone_id)
    this.$store.dispatch('getAvailableZones', this.zone_id)
  },
  methods: {
    toAssignedList () {
      for (let i = 0; i < this.selected_available_zones.length; i++) {
        let selectedZoneId = this.selected_available_zones[i]
        let zoneToMove = this.available_zones.find(
          function (ele) {
            if (ele.zone_id === selectedZoneId) {
              return true
            }
          }
        )
        this.zone.zone_zones.push({
          parent_zone_id: this.zone.zone_id,
          child_zone_id: zoneToMove.zone_id,
          child_zone: zoneToMove
        })
        this.available_zones.splice(this.available_zones.indexOf(zoneToMove), 1)
      }
    },
    toAvailableList () {
      for (let i = 0; i < this.selected_assigned_zones.length; i++) {
        let selectedZoneId = this.selected_assigned_zones[i]
        let zoneToMove = this.zone.zone_zones.find(
          function (ele) {
            if (ele.child_zone_id === selectedZoneId) {
              return true
            }
          }
        )
        this.available_zones.push(zoneToMove.child_zone)
        this.zone.zone_zones.splice(this.zone.zone_zones.indexOf(zoneToMove), 1)
      }
    },
    submit () {
      this.$store.dispatch('assignZones', { ...this.zone, push_on_success: 'ZoneManager' })
    }
  }
}
</script>

<style scoped>
  .middle-btn-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
